<span (click)="onChipClicked($event)" class="nha-chip" [ngClass]="{ 'hover': hover, 'with-icon': icon }" [class]="color">
  @if (icon) {
    <mat-icon [ngStyle]="{ 'font-size': iconSize, 'height': iconSize, 'width': iconSize }">{{ icon }}</mat-icon>
  }
  <ng-content select="[chip-content]"></ng-content>
  {{ text }}
</span>
